<template>
  <div>
    <!-- Trigger Button -->
    <v-btn 
      :disabled="disabled" 
      color="primary" 
      :loading="loading" 
      @click="dataReady = true" 
      text
      class="font-weight-black text-uppercase tracking-widest rounded-lg px-4 transition-fast-in-fast-out h-44"
    >
      <v-icon left size="16">fas fa-file-export</v-icon>
      Exportar
    </v-btn>

    <!-- Download Dialog -->
    <v-dialog v-model="dataReady" max-width="400" transition="scale-transition">
      <v-card class="modern-card overflow-hidden rounded-xl">
        <!-- Premium Header -->
        <div class="bg-grey-light pa-6 border-bottom">
          <div class="d-flex align-center">
            <v-avatar color="primary" size="40" class="mr-4 shadow-sm border-white-sm">
              <v-icon color="white" small>fas fa-download</v-icon>
            </v-avatar>
            <div>
              <div class="text-h6 font-weight-black primary--text lh-1">Exportar Insumos</div>
              <div class="caption grey--text font-weight-bold text-uppercase tracking-wider mt-1">Pendientes de Consumo</div>
            </div>
          </div>
        </div>

        <v-card-text class="text-center pa-8">
          <v-avatar color="primary lighten-5" size="80" class="mb-6">
            <v-icon color="primary" size="40">fas fa-boxes</v-icon>
          </v-avatar>
          <div class="body-1 primary--text font-weight-bold mb-2">¡Reporte de Insumos!</div>
          <div class="caption grey--text px-4 mb-6">El listado de insumos pendientes por consumir ha sido generado.</div>

          <vue-json-to-csv
            :json-data="formatedData"
            :labels="labels"
            :csv-title="csvTitle"
            :separator="';'"
            @success="val => handleSuccess(val)"
            @error="val => handleError(val)">
            <v-btn 
              color="success" 
              block 
              large 
              elevation="0"
              height="48"
              class="font-weight-black text-none rounded-lg shadow-sm"
            >
              <v-icon left>fas fa-download</v-icon>
              Descargar CSV
            </v-btn>
          </vue-json-to-csv>
        </v-card-text>

        <v-divider class="mx-8 opacity-10"></v-divider>
        <div class="pa-4 text-center">
          <v-btn text small color="grey" class="text-none font-weight-bold" @click="dataReady = false">Cerrar</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import notifications from '@/utils/notifications'
import VueJsonToCsv from 'vue-json-to-csv'
import moment from 'moment'
import numeral from 'numeral'

export default {
  name: "ExportSupplyPending",
  props: ['data', 'filter', 'options', 'disabled'],
  components: { VueJsonToCsv },
  data() {
    return {
      loading: false,
      dataReady: false,
      labels: { 
        name: { title: 'Nombre' },
        group: { title: 'Grupo' },
        unit: { title: 'Unidades' },
        qty: { title: 'Cantidad' },
        consumed: { title: 'Consumido' },
        pending: { title: 'Pendiente' },
      }
    }
  },
  computed: {
    csvTitle() {
      return `export_pending_supplies_${moment().format('DD-MM-YYYY_HHmm')}`
    },
    formatedData() {
      if (!this.data) return []
      return this.data.map(d => ({
        sku: d.sku,
        name: d.name,
        group: d.group,
        unit: d.unit,
        qty: numeral(d.qty).format('0[.]00'),
        consumed: numeral(d.consumed).format('0[.]00'),
        pending: numeral(d.pending).format('0[.]00')
      }))
    }
  },
  methods: {
    handleSuccess(val) {
      notifications.showSuccess('Insumos Exportados')
      this.dataReady = false
    },
    handleError(val) {
      notifications.showError('Error Exportando Insumos')
      this.dataReady = false
    }
  }
}
</script>

<style scoped>
.modern-card { border-radius: 12px !important; font-family: 'Outfit', sans-serif !important; }
.bg-grey-light { background-color: #f8fafc !important; }
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.06) !important; }
.border-white-sm { border: 2px solid white !important; }
.shadow-sm { box-shadow: 0 4px 12px rgba(0,0,0,0.05) !important; }
.h-44 { height: 44px !important; }
.lh-1 { line-height: 1 !important; }
.tracking-widest { letter-spacing: 1.5px; }
.tracking-wider { letter-spacing: 0.8px; }
</style>